import { render, staticRenderFns } from "./advertiser-desktop-navbar.vue?vue&type=template&id=d4e3c2a0&scoped=true"
import script from "./advertiser-desktop-navbar.vue?vue&type=script&lang=js"
export * from "./advertiser-desktop-navbar.vue?vue&type=script&lang=js"
import style0 from "./advertiser-desktop-navbar.vue?vue&type=style&index=0&id=d4e3c2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e3c2a0",
  null
  
)

export default component.exports